import * as React from 'react';

import * as styles from './PhonesPreloader.css';

export const PhonesPreloader = () => {
  return <div className={styles['loader']}></div>;
};
